export const EventTypeConfig: any = {
  RequestResponse: {
    label: 'Request & Response',
    value: 'RequestResponse',
    leftHeader: 'Request',
    rightHeader: 'Response',
    bottomHeader: 'Additional Info'
  },
  TransformedRequest: {
    label: 'Request & Transformed Request',
    value: 'TransformedRequest',
    leftHeader: 'Request',
    rightHeader: 'Transformed Request'
  },
  TransformedResponse: {
    label: 'Response & Transformed Response',
    value: 'TransformedResponse',
    leftHeader: 'Response',
    rightHeader: 'Transformed Response'
  },
  ReplayRetryHistory: {
    label: 'Replay and Retry History',
    value: 'ReplayRetryHistory',
    leftHeader: 'Replay/Retry History'
  },
  Documents: {
    label: 'Documents',
    value: 'Documents',
    leftHeader: 'Documents'
  }
};

const categories: any = {
  LoadCreated: 'Load Created',
  LoadProcessed: 'Load Processed',
  LoadProcessingStarted: 'Load Processing Started',
  LoadUpdated: 'Load Update',
  LoadValidationFailed: 'Load Validation Failed',
  LoadValidationStarted: 'Load Validation Started',
  LoadValidationScheduled: 'Load Validation Scheduled',
  ExternalPartnerRequestResponse: 'External Partner Request Response',
  TrackingMessageCreated: 'Tracking Message Created',
  RouterSendingMessageToStackSuccess: 'Router Sending Message To Stack Success',
  TrackingMessageSentToRouter: 'Tracking Message Sent To Router',
  SendingEnrichedMessageToRouter: 'Sending Enriched Message To Router'
};

const getCategory = (category: string) => categories[category] || 'Unknown';

export { getCategory };

export default EventTypeConfig;
